module.exports = __webpack_public_path__ + "media/images/maskable_fav-icon-logo_webshop.nl_white-7e3cd4dddab350967232f00f5b641991.svg";